export default __webpack_public_path__ + "static/media/appstore.50944c14.svg";